export function useToast() {
  const toast = inject('toast', null)

  const showError = error => {
    toast?.error?.(error?.value?.data?.message ?? error)
  }

  const showSuccess = msg => {
    toast?.success?.(msg)
  }

  const showWarning = msg => {
    toast?.warning?.(msg)
  }

  const showResponse = (data, error, { error_msg = 'Something Wrong!', success_msg = '' }={}) => {
    if (error?.value) {
      const message = error?.value?.data?.message ?? error?.value?.message ?? error_msg
      showError(message)
      
      return
    }

    if (data) {
      const message = data?.value?.message ?? success_msg
      if (message) {
        showSuccess(message)
      }
    }
  }

  return {
    showError,
    showSuccess,
    showResponse,
    showWarning,
  }
}
